// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Qr-z","tooltipWrapper":"Rr-z","icon":"Sr-z","tooltip":"Tr-z","content":"Ur-z"};